export default __webpack_public_path__ + "static/energie-si-resurse-eebff031dcc05c9cfe0176a97bdd787f.jpg";